import Rete from 'rete';
import NodeFileSearch from "./components/NodeFileSearch";
import CrossRootContextWrapper from "nodeEditor/CrossRootContextWrapper";

export class NodeFileSearchControl extends Rete.Control {

    static get DEFAULT_VALUE() {
        return "";
    };

    constructor(emitter, key, node, resourceType, readonly = false, labelText) {
        super(key);
        this.emitter = emitter;
        this.key = key;
        this.resourceType = resourceType;
        this.component = props => (
            <CrossRootContextWrapper>
                <NodeFileSearch {...props} />
            </CrossRootContextWrapper>
        );

        this.initial = node.data[key] || NodeFileSearchControl.DEFAULT_VALUE;
        node.data[key] = this.initial;

        this.props = {
            readonly,
            editor: this.emitter,
            labelText: labelText,
            selectedOption: null,
            sortedOptions: [],
            resourceType: resourceType,
            handleChange: (event, selectedOption, reason)  => {
                this.props.selectedOption = selectedOption;
                this.putData(this.key, selectedOption ? selectedOption.value : this.initial);
                this.update();
                this.emitter.trigger("process");
            },
            handleFocus: () => {
                this.updateSelectOptions(this.props.selectedOption ? this.props.selectedOption.value : this.initial);
            },
            setSelectedOption: (fileId) => {
                this.updateSelectOptions(fileId);

                if (this.props.selectedOption.value === fileId) {
                    this.putData(this.key, this.props.selectedOption.value);
                    this.update();
                    this.emitter.trigger("process");
                }
            }
        };

        this.emitter.on("changeNodeFilesList", ({resourceType, data, sortedOptions}) => {
            if (resourceType === this.resourceType) {
                this.updateSelectOptions(this.props.selectedOption ? this.props.selectedOption.value : this.initial);
            }
        });

        this.emitter.on("removedNodeFile", ({resourceType, fileId}) => {
            if (resourceType === this.resourceType) {
                // if removed option was currently selected - then remove it also from props.selectedOption,
                // (set field default value) so it won't show in currently selected option field
                // and also clear file value in nodes (this.putData)
                if (this.props.selectedOption && fileId === this.props.selectedOption.value) {
                    this.props.selectedOption = null;
                    this.initial = NodeFileSearchControl.DEFAULT_VALUE;
                    this.putData(this.key, this.initial);
                    this.updateSelectOptions(this.initial);
                }
            }
        });

        this.updateSelectOptions(this.initial);
    }

    updateSelectOptions(selectedValue) {
        this.props.sortedOptions = this.emitter.storage.getSortedOptions(this.resourceType) || [];

        if (selectedValue !== NodeFileSearchControl.DEFAULT_VALUE) {
            let foundSelected = this.props.sortedOptions.find(selectOption => selectOption.value === selectedValue);
            if (foundSelected !== undefined) {
                this.props.selectedOption = foundSelected;
            }
        }

        if (typeof this.update === 'function') {
            this.update();
        }
    }
}
